import { render } from "./AcessComp.vue?vue&type=template&id=6acfe100"
const script = {}

import "./AcessComp.vue?vue&type=style&index=0&id=6acfe100&lang=css"

import exportComponent from "/Users/rhylton/Sites/projeto-obras/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__